export const getComponentByClass = (
  container: Document | Element,
  className: string
): Element | null => {
  const classNameList = `.${className.split(' ').join('.')}`

  return container.querySelector(classNameList)
}
